import { SubmitButton } from '@/components/submit-button';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet';

import { useToggle } from '@/hooks/use-toggle';
import { useCurrentUser } from '@/hooks/useCurrentUser';

import { useChangePasswordMutation } from '@/query/auth.query';

import { humanizeDateDifference } from '@/lib/date';

import { ChangePasswordForm } from './change-password-form';

import { ChangePasswordFormProvider } from '@/formik/user.formik';

export const ChangePassword = () => {
  const { toggle, state } = useToggle();
  const { userData } = useCurrentUser();

  const mutation = useChangePasswordMutation({
    onSuccess: () => {
      toggle();
    },
  });

  const getLastPasswordChangeText = () => {
    if (!userData?.last_password_change_at) {
      return 'Never changed';
    }

    return `Last changed ${humanizeDateDifference(new Date().toISOString(), userData.last_password_change_at)}`;
  };

  return (
    <Card className="bg-muted rounded-2xl p-1 pt-0 gap-0 border-0 shadow-none flex flex-col">
      <CardHeader className="flex flex-col px-5 py-3">
        <CardTitle className="text-sm">Security</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-3 bg-card p-5 rounded-xl shadow-sm flex-1">
        <div className="flex items-center justify-between">
          <div>
            <p className="font-medium">Password</p>
            <p className="text-sm text-muted-foreground">{getLastPasswordChangeText()}</p>
          </div>
          <Sheet open={state} onOpenChange={toggle}>
            <SheetTrigger asChild>
              <Button variant="outline">Change password</Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-full sm:max-w-md overflow-y-auto p-0">
              <SheetHeader className="p-4 w-full relative">
                <SheetTitle>Change password</SheetTitle>
                <SheetDescription>
                  Update your password to keep your account secure.
                </SheetDescription>
              </SheetHeader>
              <ChangePasswordFormProvider onSubmit={mutation.mutate}>
                <ChangePasswordForm />
                <SheetFooter className="sticky bottom-0 bg-background border-t p-4 w-full flex flex-row gap-2">
                  <Button type="button" variant="outline" onClick={toggle} className="flex-1">
                    Cancel
                  </Button>
                  <SubmitButton isPending={mutation.isPending} label="Change password" />
                </SheetFooter>
              </ChangePasswordFormProvider>
            </SheetContent>
          </Sheet>
        </div>
      </CardContent>
    </Card>
  );
};
